import { render, staticRenderFns } from "./SanityTable.vue?vue&type=template&id=475486f2"
import script from "./SanityTable.vue?vue&type=script&lang=js"
export * from "./SanityTable.vue?vue&type=script&lang=js"
import style0 from "./SanityTable.vue?vue&type=style&index=0&id=475486f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports